/**
 * Listing badge helpers for Discover and shared listing cards.
 *
 * "New" is a placeholder until the API exposes listing age.
 * Suggested rule once wired: after near-you / localization filtering,
 * mark a listing New if date_created is within NEW_LISTING_WINDOW_DAYS.
 * 30 days (not 14) is the better default while the app is still filling
 * in local supply — 14 days would hide the badge too quickly.
 */
export const NEW_LISTING_WINDOW_DAYS = 30

/**
 * The Verified checkmark badge requires both:
 * 1. A qualifying tier (Verified Business or Enhanced, i.e. not a Basic
 *    marketing placeholder) -- this is the pre-existing verified/enhanced check.
 * 2. A sufficiently complete profile -- what counts differs by account type,
 *    since producers and markets have different core building blocks:
 *    - producer: business description, products, selling locations, sales channels
 *    - market: business description, vendors, selling locations
 * If user_type is missing from the data passed in, this fails closed (no badge)
 * rather than guessing which set of completion fields to check.
 */
export function listingShowsVerified(listing?: {
  verified?: boolean | null
  enhanced?: boolean | null
  user_type?: string | null
  business_description_completed?: boolean | null
  products_completed?: boolean | null
  vendors_completed?: boolean | null
  selling_locations_completed?: boolean | null
  sales_channels_completed?: boolean | null
} | null): boolean {
  if (!listing) return false

  const isQualifyingTier = listing.verified === true || listing.enhanced === true
  if (!isQualifyingTier) return false

  const userType = listing.user_type?.toLowerCase()
  if (userType === 'market') {
    return !!listing.business_description_completed &&
      !!listing.vendors_completed &&
      !!listing.selling_locations_completed
  }
  if (userType === 'producer') {
    return !!listing.business_description_completed &&
      !!listing.products_completed &&
      !!listing.selling_locations_completed &&
      !!listing.sales_channels_completed
  }
  return false
}

/** Preview-only: show New on the first two localized results. */
export function isNewListingPlaceholder(index: number): boolean {
  return index < 2
}
